import { features } from '@/mocks/homepage';

export default function FeatureSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            为什么选择我们
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            六大核心优势，为您提供最优质的入口导航服务
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature, i) => (
            <div
              key={i}
              className="p-6 rounded-lg bg-background-50 border border-secondary-200/60 hover:border-accent-200 transition-all duration-300 group"
            >
              <div className="w-11 h-11 rounded-lg bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors duration-300">
                <i className={`${feature.icon} text-accent-600 text-xl`} />
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}